import classnames from 'classnames/bind'
import {
  RichText as PrismicRichText,
  RichTextProps as PrismicRichTextProps,
} from 'prismic-reactjs'
import React, { forwardRef } from 'react'

import linkResolver from '~/utils/link-resolver'

import getHtmlSerializer from './get-html-serializer'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface RichTextProps extends PrismicRichTextProps {
  className?: string
  children?: undefined
  innerRef?: any
  style?: object
}
/**
 * Prismic richtext component
 * @param props
 * @returns Component
 */
function RichText({ className, innerRef, style, ...props }: RichTextProps) {
  const htmlSerializer = getHtmlSerializer()
  //@ts-ignore https://github.com/prismicio/prismic-reactjs/pull/69
  return (
    <div ref={innerRef} className={cx(className, css.RichText)} style={style}>
      <PrismicRichText
        htmlSerializer={htmlSerializer}
        linkResolver={linkResolver}
        {...props}
      />
    </div>
  )
}

export type { RichTextBlock } from 'prismic-reactjs'
export { RichText as PrismicRichText } from 'prismic-reactjs'

export default forwardRef<HTMLDivElement, RichTextProps>((props, ref) => (
  <RichText innerRef={ref} {...props} />
))
